import moment from 'moment';

const NpsTabelaPorDia = ({ filiais, dados }) => {
  return (
    <div className="overflow-auto bg-white p-4 rounded shadow">
      <h3 className="text-xl font-semibold text-gray-700 mb-4">NPS Realiazados por Dia</h3>
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="text-left px-4 py-2 border">Data</th>
            {filiais.map(filial => (
              <th key={filial} className="text-left px-4 py-2 border">{filial}</th>
            ))}
            <th className="text-left px-4 py-2 border">Total</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((linha, idx) => (
            <tr key={idx} className="hover:bg-gray-50">
              <td className="px-4 py-2 border">{moment(linha.data).format('DD/MM/YYYY')}</td>
              {filiais.map(filial => (
                <td key={filial} className="px-4 py-2 border">
                  {linha.porFilial[filial] || 0}
                </td>
              ))}
              <td className="px-4 py-2 border font-semibold">{linha.total}</td>
            </tr>
          ))}
            {dados.length === 0 && (
              <tr>
                <td colSpan="8" className="text-center py-4 text-gray-500">
                  Nenhum dado encontrado para o período.
                </td>
              </tr>
            )}
        </tbody>
      </table>
    </div>
  );
};

export default NpsTabelaPorDia;
